import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthFrame } from "@/layout/AuthFrame";
import { Btn, Field, Overline } from "@/components/kit";
import { api, apiError } from "@/lib/api";
import { toast } from "@/components/ui/sonner";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return toast.error("Please enter your email.");
    setLoading(true);
    try {
      const { data } = await api.post("/api/auth/forgot-password", { email: email.trim() });
      setSent(true);
      toast.success(data.message);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthFrame>
      <Overline className="text-center mb-3">Reset your password</Overline>
      <h1 className="font-serif text-4xl text-ink text-center">Forgot password</h1>
      <p className="text-inkfaint text-center mt-2 mb-8">
        Enter your email and we'll send a 6-digit code to reset your password.
      </p>
      {sent ? (
        <div className="text-center space-y-6">
          <p className="text-inksoft">If that account exists, a reset code has been sent.</p>
          <Btn className="w-full" onClick={() => navigate("/reset-password", { state: { email: email.trim() } })}
            data-testid="have-code-btn">I have a code</Btn>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <Field label="Email" type="email" placeholder="you@example.com" value={email}
            onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" autoComplete="email" />
          <Btn type="submit" className="w-full" disabled={loading} data-testid="forgot-submit">
            {loading ? "Sending…" : "Send reset code"}
          </Btn>
        </form>
      )}
      <p className="text-center text-sm mt-8">
        <Link to="/reset-password" className="text-gold hover:underline" data-testid="already-code">
          I already have a code
        </Link>
      </p>
    </AuthFrame>
  );
}
